<template>
  <div class="home">
    <div >
            <div>
                
                <section>
                    <div class="py-8 px-8">
                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                        <div class="col-12 col-lg-auto mb-4 mb-lg-0">
                        <div class="d-flex align-items-center">
                            <h4 class="mb-0 me-2">{{$t('logs')}}</h4>
                        </div>
                        </div>
                        <div class="col-12 col-lg-auto d-flex align-items-center">
                        <!-- <div class="input-group pe-4 bg-white rounded border">
                            <input class="form-control border-0 search-input" autocomplete="off" type="text" v-model="search" :placeholder="$t('search')">
                            <button class="btn p-0" type="button">
                            <AppIcon name="bi-search" class="bi bi-search" style="font-size:18px" />
                            </button>
                        </div> -->
                        </div>
                    </div>
                    </div>
                </section>
            </div>
      
            <section class="py-8">
                <div class="px-8">
                <div class="page-table-container mb-6 bg-white rounded shadow">
                    
                    <!-- table -->
                    <div class="table-responsive">
                        <table class="table mb-0 table-borderless table-striped small">
                            <thead>
                                <tr class="text-secondary">
                                    <sortable-table-header field="id" label="id" :sort-field="sortField" :sort-direction="sortDirection" @sort="sortLogs" />
                                    <th class="pt-4 pb-3 px-6">{{$t('user')}}</th>
                                    <sortable-table-header field="action" label="action" :sort-field="sortField" :sort-direction="sortDirection" @sort="sortLogs" />
                                    <sortable-table-header field="created_at" label="created_at" :sort-field="sortField" :sort-direction="sortDirection" @sort="sortLogs" />
                                    <th class="pt-4 pb-3 px-6">{{$t('details')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="log in logs" :key="log.id">
                                <td class="py-5 px-6">
                                    <span class="log-id" :title="log.id">{{ shortId(log.id) }}</span>
                                </td>
                                <td class="py-5 px-6">{{log?.user?.name || '-'}}</td>
                                <td class="py-5 px-6">
                                    <span
                                        v-if="log.action"
                                        class="badge rounded-pill small log-action-badge"
                                        :class="actionBadgeClass(log.action)"
                                        :title="log.action"
                                    >
                                        <AppIcon :name="actionIcon(log.action)" class="bi me-1" :class="actionIcon(log.action)" />{{ formatAction(log.action) }}
                                    </span>
                                    <span v-else>-</span>
                                </td>
                                <td class="py-5 px-6">
                                    <span :title="log.created_at">{{ formatDate(log.created_at) }}</span>
                                </td>
                                <td class="py-5 px-6">
                                     <button @click="show(log)" class="btn btn-primary btn-xs log-details-button">
                                        <AppIcon name="bi-eye" class="bi bi-eye me-1" />{{$t('view')}}
                                    </button>
                                </td>
                            </tr>

                            </tbody>
                        </table>

                        <div v-if="count > logs.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                            <button @click="getLogs(true)" class="btn p-0" type="button">{{$t('load_more')}}</button>
                        </div>
                    </div>
                    <!-- table -->
                    <table-loading-bar v-if="loading" class="page-table-state text-center" />
                    <div v-if="loading === false && !logs.length" class="page-table-state text-center" style="padding:1rem">{{$t('no_data')}}.</div>

                </div>

                </div>
            </section>
      </div>

        <!-- create Modal -->
        <div class="modal fade" id="create-modal" tabindex="-1" aria-labelledby="create-modal" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$t('log')}}</h5>
                    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div class="modal-body" style="text-align:left">
                    <pre>{{log.data}}</pre>
                    <div v-if="log.action == 'ADD_DELIVERY'" style="text-align:center">
                        <button @click="retryRequest(log)" class="btn btn-primary">
                        Retry Request 
                        </button>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                    
                </div>
                </div>
            </div>
        </div>
        <!-- create modal -->

  </div>
</template>

<script>
import helper from '../helper'
import moment from 'moment'
import sortableList from '../mixins/sortableList'
// import Log from '../components/Log.vue'
export default {
  name: 'User',
  persistedFilterState: { key: 'logs', fields: ['search', 'sortField', 'sortDirection'] },
  mixins: [sortableList],
//   components : {
//     Log
// },
  data(){
    return {
        search : '',
        timer_id : null,
        count : 0,
        logs : [],
        log : {
            data : {}
        },
        createModal : null,
        editModal : null,
        loading: false,
        manage_inventories : false,
        manage_orders : false,
        manage_purchases : false,
        manage_clients : false,
        manage_suppliers : false,
    }
  },
  mounted(){
    window.mixpanel.track("log");

    this.getLogs()

    // eslint-disable-next-line no-undef
    this.createModal = new bootstrap.Modal(document.getElementById('create-modal'))
    
  },
methods : {
    shortId(id) {
        return helper.shortId(id)
    },
    formatAction(action) {
        if (!action) return '-'

        const translationKey = String(action).toLowerCase()
        if (this.$te(translationKey)) return this.$t(translationKey)

        const label = translationKey.replace(/_/g, ' ').trim()
        return label.charAt(0).toUpperCase() + label.slice(1)
    },
    actionBadgeClass(action) {
        const normalizedAction = String(action || '').toLowerCase()

        if (/(delete|deleted|remove|trash)/.test(normalizedAction)) return 'bg-danger'
        if (/(edit|edited|update|updated)/.test(normalizedAction)) return 'bg-info text-dark'
        if (/(add|added|create|created)/.test(normalizedAction)) return 'bg-success'
        if (/(restore|renew)/.test(normalizedAction)) return 'bg-warning text-dark'
        return 'bg-primary'
    },
    actionIcon(action) {
        const normalizedAction = String(action || '').toLowerCase()

        if (/(delete|deleted|remove|trash)/.test(normalizedAction)) return 'bi-trash'
        if (/(edit|edited|update|updated)/.test(normalizedAction)) return 'bi-pencil'
        if (/(add|added|create|created)/.test(normalizedAction)) return 'bi-plus-circle'
        if (/(restore|renew)/.test(normalizedAction)) return 'bi-arrow-counterclockwise'
        if (normalizedAction.includes('login')) return 'bi-box-arrow-in-right'
        return 'bi-activity'
    },
    sortLogs(field){
            this.toggleSort(field)
            this.getLogs(false)
    },
    show(log){
            this.log = log
            // eslint-disable-next-line no-undef
            this.createModal.show()
    },
    async getLogs(loadMore){
            try{
                    this.loading = true
                    this.page = loadMore ? this.page+1 : 1
                    this.logs = this.page == 1 ? [] : this.logs
                    const params = new URLSearchParams({ page: this.page })
                    this.appendSortParams(params)
                    const response = await helper.customGet(`${process.env.VUE_APP_API}/logs?${params.toString()}`)
                    this.logs = this.logs.length ? [...this.logs, ...response.data.data] :  response.data.data
                    this.count = response.data.count 
                    this.loading = false 
            }catch(error){
                    this.loading = false 
            }

    },
    async retryRequest(log){
             const result = await this.$swal.fire({
                    title: `${this.$t('are_you_sure')}?`,
                    text : this.$t('you_cant_revert'),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: this.$t('confirm')
            })
            if (result.isConfirmed) {

                    if(log.action == 'ADD_DELIVERY'){
                            log.data.test = true;
                            if(log.data.test === true){
                                    log.data.reference = `TEST+++${log.data.reference}`
                            }
                            const response = await helper.customPost(`${process.env.VUE_APP_API}/deliveries`, {...log.data, products : [...log.data.products],retry_from_log : true},{showToast:false})
                            
                            window.vueOpener.open({
                                    message: this.$t('delivery_successfully_created'),
                                    type: 'success',
                                    position : 'bottom'
                            });

                            this.createModal.hide()
                            this.$router.push({path : `/deliveries/${response.data.id}`})
                    }

            }
    },
    //helper functions
    formatDate(date) {
        if (!date) return '-';
        return moment(date).fromNow()
    }
  },
  watch : {
    async search(){
        if(this.search.length > 2){
            try{
                clearTimeout(this.timer_id);
                this.timer_id = setTimeout(async () => {
                   this.loading = true
                    const response = await helper.customPost(`${process.env.VUE_APP_API}/logs/search`,{keyword : this.search})
                    this.logs = response.data.data
                    this.count = response.data.count
                    this.loading = false
                }, 1000);
            }catch(error){
                this.loading = false
            }

        }
        if(this.search == '') return this.getLogs()
    }
  },
  computed : {
    role(){ return this.$store.getters.ROLE },
    permissions(){ return this.$store.getters.PERMISSIONS }
  }
}
</script>
<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }

    .log-id {
        color: #6c757d;
        font-family: monospace;
        white-space: nowrap;
    }

    .log-action-badge {
        font-weight: 500;
        white-space: nowrap;
    }

    .log-details-button {
        margin: 0;
        padding: 5px 8px;
        font-size: 12px !important;
        white-space: nowrap;
    }
</style>
